import { createSelector } from '@ngrx/store';
import { AppState } from '../../../../store/state/app.state';
import { CommonUtils } from '../../../shared/utils/common-utils';
import { ActivityState } from '../state/activity.state';

export const selectActivityState = (state: AppState) => state.activity;

export const selectActivityRecords = createSelector(selectActivityState, (state: ActivityState) => state.activityRecords);
export const selectNumberOfActivityRecords = createSelector(selectActivityState, (state: ActivityState) => state.numberOfActivityRecords);

export const selectVerificationStatus = createSelector(selectActivityState, (state: ActivityState) => state.verificationStatus);
export const selectLimit = createSelector(selectActivityState, (state: ActivityState) => state.limit);
export const selectOffset = createSelector(selectActivityState, (state: ActivityState) => state.offset);

export const selectFilter = createSelector(selectActivityState, (state: ActivityState) => state.filter);
export const selectFilterApplied = createSelector(selectFilter, filter => Object.values(filter).some(value => CommonUtils.isDefinedAndNonEmptyString(value)));

export const selectNumberOfMissingActivityRecords = createSelector(selectActivityState, (state: ActivityState) => state.numberOfMissingActivityRecords);
